import BlankCart from '@components/blank/BlankCart';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import useViewCart from '@hooks/analytics/useViewCart';
import useCart from '@hooks/cart/useCart';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useActivity } from '@stackflow/react';
import usePrepareWithCart from '@store/cart/hooks/usePrepareWithCart';
import { Fragment, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import CartFooter from './components/CartFooter';
import CartItems from './components/CartItems';
import CartNote from './components/CartNote';
import ShopLocation from './components/ShopLocation';
import useBulkUpdateCartQuantity from './hooks/useBulkUpdateCartQuantity';

interface Params {
    shopId: string
}

declare module '@stackflow/config' {
    interface Register {
        CartActivity: Params;
    }
}

const CartActivity: ActivityComponentType<'CartActivity'> = ({ params }) => {
    const { shopId } = params;
    const { isFetching, cart, isBlank } = useCart(shopId);
    useViewCart({ cart, shopId });
    const { t } = useTranslation('cart');
    const bulkUpdate = useBulkUpdateCartQuantity({
        shopId, cartId: cart?.cartId,
    });
    usePrepareWithCart(shopId);

    const { transitionState } = useActivity();
    // exit 전환 중 리렌더링되어도 한 번만 반영
    const isExitUpdated = useRef(false);
    useEffect(() => {
        if (transitionState === 'exit-active' && !isExitUpdated.current) {
            isExitUpdated.current = true;
            bulkUpdate();
        }
    }, [transitionState, bulkUpdate]);
    return (
        <AppScreen>
            <CtaLayout header={<Header title={t('header.title')} />}
                footer={<CartFooter shopId={shopId} cartId={cart?.cartId}/>} >
                <ShopLocation/>
                {cart && (
                    <Fragment>
                        <CartItems shopId={shopId} cartId={cart.cartId} />
                        <CartNote/>
                    </Fragment>
                )}
                {isBlank && (<BlankCart/>)}
                {isFetching && <Loading size='small' /> }
            </CtaLayout>
        </AppScreen>
    );
};

export default CartActivity;
